module.exports = __webpack_public_path__ + "static/media/21ECLAC46.579d12cd.jpg";